import React, { useCallback, useMemo } from 'react';

import type { PersistContextType } from '@/core/lib/persist/persist.context';
import { PersistContext } from '@/core/lib/persist/persist.context';

const PersistProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  // Local
  const getLocal = useCallback(async (key: string) => {
    try {
      return localStorage.getItem(key);
    } catch {
      return null;
    }
  }, []);
  const setLocal = useCallback(async (key: string, value: string) => {
    try {
      localStorage.setItem(key, value);
    } catch {
      // do nothing
    }
  }, []);
  const removeLocal = useCallback(async (key: string) => {
    try {
      localStorage.removeItem(key);
    } catch {
      // do nothing
    }
  }, []);

  // Session
  const getSession = useCallback(async (key: string) => {
    try {
      return sessionStorage.getItem(key);
    } catch {
      console.error(`"${key}" n'a pas pu être get dans le sessionStorage`);
      return null;
    }
  }, []);
  const setSession = useCallback(async (key: string, value: string) => {
    try {
      sessionStorage.setItem(key, value);
    } catch (e) {
      console.error(`"${key}" n'a pas pu être set dans le sessionStorage`, e);
    }
  }, []);
  const removeSession = useCallback(async (key: string) => {
    try {
      sessionStorage.removeItem(key);
    } catch {
      console.error(`"${key}" n'a pas pu être remove dans le sessionStorage`);
    }
  }, []);

  const value = useMemo(() => ({ getLocal, setLocal, removeLocal, getSession, setSession, removeSession }) satisfies PersistContextType, []);

  return <PersistContext.Provider value={value}>{children}</PersistContext.Provider>;
};

export default PersistProvider;
